import React from 'react';
import PropTypes from 'prop-types';
import ToggleButton from '../toggle-button/ToggleButton.jsx';
import MapNoteFilterInfo from './MapNoteFilterInfo.jsx';
import MapNoteFilterMenu from './MapNoteFilterMenu.jsx';
import s from './MapNoteFilter.module.scss';

const MapNoteFilter = props => {
    const totals = props.totals || { open: 0, resolved: 0 };

    const amount = props.status === 'all' ? totals.open + totals.resolved : totals[props.status];
    return (
        <div className={s.mapNoteFilter}>
            <div className={s.buttons}>
                <ToggleButton
                    active={props.showNotesOnMap}
                    activeIcon="icon-newmapnote"
                    activeText="Hide Map Notes "
                    inactiveIcon="icon-map-note-hidden"
                    inactiveText="Show Map Notes"
                    onButtonClick={props.onButtonClick}
                    showTooltip={!props.expanded && !props.otherExpanded}
                    arrowPosition="top"
                    borderType="left"
                    className={s.toggleButtonSize}
                />
                <MapNoteFilterInfo active={props.showNotesOnMap} expanded={props.expanded} status={props.status} amount={amount} onClick={props.onFilterClick} />
            </div>
            {props.expanded && <MapNoteFilterMenu status={props.status} type={props.type} totals={totals} onStatusClick={props.onStatusClick} onTypeClick={props.onTypeClick} />}
        </div>
    );
};

MapNoteFilter.propTypes = {
    showNotesOnMap: PropTypes.bool.isRequired,
    expanded: PropTypes.bool.isRequired,
    otherExpanded: PropTypes.bool.isRequired,
    status: PropTypes.string.isRequired,
    type: PropTypes.objectOf(PropTypes.bool).isRequired,
    totals: PropTypes.objectOf(PropTypes.number).isRequired,
    onButtonClick: PropTypes.func.isRequired,
    onFilterClick: PropTypes.func.isRequired,
    onStatusClick: PropTypes.func.isRequired,
    onTypeClick: PropTypes.func.isRequired,
};

export default MapNoteFilter;
